/**
 * Copies text to the clipboard, tolerating embedded contexts. The async
 * Clipboard API is blocked by permissions policy when the MFE runs in an
 * iframe without allow="clipboard-write" (older Phoenix host builds), so a
 * hidden-textarea execCommand fallback covers that case.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    // Fall through to the legacy approach
  }

  try {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    const copied = document.execCommand("copy")
    document.body.removeChild(textarea)
    return copied
  } catch {
    return false
  }
}
